import type { CompanyStatus, SubmissionStatus } from '../lib/types.ts';

const COMPANY_LABELS: Record<CompanyStatus, { label: string; cls: string }> = {
  invited: { label: 'Invited', cls: 'bg-slate-100 text-slate-700' },
  in_progress: { label: 'In progress', cls: 'bg-blue-50 text-blue-700' },
  review: { label: 'In review', cls: 'bg-amber-50 text-amber-700' },
  changes: { label: 'Changes requested', cls: 'bg-orange-50 text-orange-700' },
  compliant: { label: 'Compliant', cls: 'bg-emerald-50 text-emerald-700' },
  expired: { label: 'Expired', cls: 'bg-red-50 text-red-700' },
};

const SUBMISSION_LABELS: Record<SubmissionStatus, { label: string; cls: string }> = {
  pending: { label: 'Pending', cls: 'bg-slate-100 text-slate-700' },
  approved: { label: 'Approved', cls: 'bg-emerald-50 text-emerald-700' },
  rejected: { label: 'Changes requested', cls: 'bg-orange-50 text-orange-700' },
};

export function CompanyStatusBadge({ status }: { status: CompanyStatus }) {
  const cfg = COMPANY_LABELS[status];
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}

export function SubmissionStatusBadge({ status }: { status: SubmissionStatus }) {
  const cfg = SUBMISSION_LABELS[status];
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}
